import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '../../core-ui/Icons/Icons.module';
import { TooltipModule } from '../Tooltip/Tooltip.module';
import { FiveStarRatingComponent } from './five-star-rating.component';

export const FiveStarRatingModuleExports = [FiveStarRatingComponent];

@NgModule({
    imports: [CommonModule, TooltipModule, IconsModule],
    declarations: [...FiveStarRatingModuleExports],
    exports: [...FiveStarRatingModuleExports],
    providers: []
})
export class FiveStarRatingModule {}
